import createAction from 'redux-actions/es/createAction'

export const receive = createAction('BATCHES/WIDGET/RECEIVE')
export const untrack = createAction('BATCHES/WIDGET/UNTRACK')
export const untrackFinished = createAction('BATCHES/WIDGET/UNTRACK_FINISHED')
export const trackTemp = createAction('BATCHES/WIDGET/TRACKTEMP')
